import publicInquiryAxiosInstance from 'axios';

const publicinquiryapi = publicInquiryAxiosInstance.create({

});

publicinquiryapi.defaults.baseURL = process.env.VUE_APP_PUBLIC_INQUIRY_URL;
publicinquiryapi.defaults.headers.post['Content-Type'] = 'application/json';

publicinquiryapi.interceptors.response.use((response: any) => {
    return response;
}, (error: any) => {
    if (typeof error.response !== 'undefined' && error.response.status === 401) {

        publicinquiryapi.defaults.headers.common.Authorization = '';

    }

    throw error;
});

export default publicinquiryapi;
